import { connect } from 'react-redux';
import { NS } from '../../reducers/auth';

import App from './App';

export default App;
